import Vue from 'vue';
import Router from 'vue-router';
import auth from './utils/auth';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'List',
      component: () => import('./views/List.vue'),
    },

    {
      path: '/jobs/:id',
      name: 'Details',
      component: () => import('./views/Details.vue'),
    },
    {
      path: '/callback',
      name: 'Callback',
      component: () => import('./views/Callback.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.path === '/login' || to.path === '/callback' || (await auth.isAuthenticated())) {
    return next();
  }
  return next('/login');
});
export default router;
